module.exports = __webpack_public_path__ + "img/image12.89d4890b.png";